import { createSlice } from "@reduxjs/toolkit";
const currentCurrency = localStorage.getItem("currency");
const initialState = currentCurrency ? JSON.parse(currentCurrency) : {};
const currencySlice = createSlice({
  initialState,
  name: "currencySlice",
  reducers: {
    changeCurrency: (state, action) => (state = action.payload),
  },
});
export default currencySlice.reducer;
export const { changeCurrency } = currencySlice.actions;
